import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import PRHistoryTracker from "./PRHistoryTracker";
import { setActiveDataElement } from "../../../redux/userSlice";



const PRHistory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Production Requirement"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Production Requirement Upload History"
            />
            <div class="container">
              {/* top table */}
              <PRHistoryTracker />
             
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default PRHistory;
